import React from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import { useNavigate } from "react-router-dom";
import "./IntakeFormPagesCommon.css";

const IntakeFormPage2: React.FC = () => {
  const navigate = useNavigate();
  const handleNext = () => {
    navigate("/complete-intake/step-1");
  };

  return (
    <PageWrapper>
      <div className="signup-page-container">
        <div className="signup-content">
          <p
            className="intake-form-content-header"
            style={{ marginBottom: "80px" }}
          >
            It looks like you&apos;ve got a few more details to add to your
            intake form. Let&apos;s finish it up.
          </p>

          <button className="next-btn sticky-btn" onClick={handleNext}>
            Next →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage2;
